import { render } from "./SpendingTrendChart.vue?vue&type=template&id=49fc240b&scoped=true"
import script from "./SpendingTrendChart.vue?vue&type=script&lang=js"
export * from "./SpendingTrendChart.vue?vue&type=script&lang=js"

import "./SpendingTrendChart.vue?vue&type=style&index=0&id=49fc240b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fc240b"]])

export default __exports__